
import {
  defineComponent,
  Ref,
  ref,
  onMounted,
  nextTick,
  watch,
} from "vue";
import { Modal } from "bootstrap";
import Api from "@/services/Api";
import ModalDadosLoja from "./components/ModalDadosLoja.vue";

interface Consultor {
  id: number,
  nome: string,
  email: string,
  regiao: string,
  cargo: string,
  created_at: string,
  updated_at: string
}


export default defineComponent({
  name: "CarteiraConsultor",

  components: {
    ModalDadosLoja
  },

  setup() {
    const modalDadosLoja: Ref<any> = ref()
    const loja: Ref<any> = ref({})

    const consultores: Ref<Consultor[]> = ref([])
    const arrayDados: Ref<any> = ref([])
    const consultorSelected: Ref<Consultor | null> = ref(null);

    const loadConsultores: Ref<boolean> = ref(false);
    const loadDados: Ref<boolean> = ref(false);
    const fastFind: Ref<string> = ref('');


    function openModal(data) {
      loja.value = data
      modalDadosLoja.value.show();
    }

    async function fechaModal() {
      modalDadosLoja.value.hide();
    }

    async function getConsultores(){
      loadConsultores.value = true
      try{
        const { data, error, message } = await Api.get("buscaUsuarioIpirangaPaginado")
        consultores.value = data.users

      }catch(error){
        console.log("error", error)
      }finally {
        loadConsultores.value = false
      }
    }

    async function getDadosCarteiraConsultor(idConsultor){
      loadDados.value = true
      try{
        const { data } = await Api.get("getDadosCarteiraConsultor", {idConsultor, fastFind: fastFind.value})
        arrayDados.value = data

      }catch(error){
        console.log("error", error)
      }finally {
        loadDados.value = false
      }
    }

  watch(
    () =>consultorSelected.value,
    () => {
      console.log("consultorSelected", consultorSelected.value)
      if(consultorSelected.value?.id){
        getDadosCarteiraConsultor(consultorSelected.value.id)
      }
    }
  )

  watch(
    () => fastFind.value,
    () => {
      if((consultorSelected.value?.id && fastFind.value.length > 2) || (consultorSelected.value?.id && !fastFind.value)){
        getDadosCarteiraConsultor(consultorSelected.value.id)
      }
    }
  )

  watch(arrayDados, async () => {
    await nextTick();
    const headers = document.querySelectorAll('.card-header');
    headers.forEach(header => {
      const title = header.querySelector('.card-title');
      if (title && title.scrollWidth > header.clientWidth) {
         header.classList.add('tem-animacao');

        // Em dispositivos móveis, ativa a animação no toque
        header.addEventListener('touchstart', () => {
          title.classList.add('animar');
        });

        // Opcional: parar a animação no fim do toque
        header.addEventListener('touchend', () => {
          title.classList.remove('animar');
        });
      }
    });
  });

  onMounted(async () => {
    modalDadosLoja.value = new Modal(document.querySelector("#modalDadosLoja"));
    getConsultores();
  })

    

    return {
      history,
      openModal,
      fechaModal,
      loja,
      loadConsultores,
      loadDados,
      fastFind,
      consultores,
      consultorSelected,
      arrayDados,
      getDadosCarteiraConsultor
    };
  },
});
